// NOT USED ANYMORE - REMOVE?
import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition } from '../../models';
import { IGroupService, ISeriesSelectorService } from '../../services';
import { groupTreeChanged, treeUpdated, groupAdded, groupSelected } from '../../common';
import { ModelWidget } from './model.widget';

class ModelController implements angular.IComponentController {
    groups: any;
    isLoading: boolean;
    item: ModelWidget;
    loadingMessage: string;
    root: any;

    static $inject = [
        '$scope',
        '$rootScope',
        '$q',
        'groupService',
        'seriesSelectorService'
    ];

    constructor(private $scope: angular.IScope,
        private $rootScope: angular.IRootScopeService,
        private $q: angular.IQService,
        private _groupService: IGroupService,
        private _seriesSelectorService: ISeriesSelectorService) {
    }

    $onInit() {
        this.refreshTree();

        this.$scope.$on(groupTreeChanged, () => {
            this.refreshTree();
            this._seriesSelectorService.cleanCache();
            this.$rootScope.$broadcast(treeUpdated);
        });
        this.$scope.$on(groupAdded, (event, data) => {
            if (data && !data.isCreating) {
                this.refreshTree().then((tree: any[]) => {
                    const selectedGroup = _.find(tree, (d: any) => d.guid === data.guid);
                    this.$rootScope.$broadcast(groupSelected, selectedGroup);
                });
            }
        });
    }

    private refreshTree() {
        const defered = this.$q.defer();
        this.isLoading = true;
        this._groupService.getAllAsTree()
            .then(data => {
                this.groups = [data[0]];
                this.root = this.groups[0];
                this.isLoading = false;
                defered.resolve(data);
            })
            .catch(() => {
                defered.reject();
            });
        return defered.promise;
    }
}

export const wtModel: ComponentDefinition = {
    componentId: 'wtModel',
    controller: ModelController,
    template: require('./model.component.html'),
    controllerAs: 'vm',
    bindings: {
        item: '='
    }
};
